import $ from 'jquery'
import 'slick-carousel'

const testimonials_carousel = $('.testimonials-carousel')

testimonials_carousel.slick({
	autoplay: true,
	autoplaySpeed: 4000,
	centerMode: false,
	centerPadding: '100px',
	infinite: true,
	slidesToShow: 3,
	arrows: true,
	dots: false,
	responsive: [
		{
			breakpoint: 1260,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 1090,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 700,
			settings: {
				slidesToShow: 1,
			},
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 1,
			},
		},
	],
})

testimonials_carousel.show()
